<template>
	<div class="appr-container m-0 p-0" style="background-color: #000000;">
		<div class="container-fluid my-0" v-if="(isMobile && !isPortrait) || !isMobile">
			<div class="row justify-content-center m-0" v-if="videoReady">
				<div id="full-video-container" class="col-lg-10 position-relative m-0">
					<div class="inner-vid-conteiner m-0 w-100">
						<div class="inner-vid-wrap m-0 w-100">
							<div class="vid-wrapper w-100 h-100 position-relative">

								<!-- First video -->
								<transition name="fade">
									<video
										ref="scf1"
										v-show="(videoNo == 1)"
										:controls="false"
										controlsList="nodownload"
										:height="videosData[0].videoH"
										:width="videosData[0].videoW"
										@timeupdate="videoTimeWatch"
										webkit-playsinline
										playsinline
									>
										<source :src="videosData[0].videoSrc" type="video/mp4">
										Your browser does not support the video tag.
									</video>
								</transition>

								<!-- Second video -->
								<transition name="fade">
									<video
										ref="scf2"
										v-show="(videoNo == 2)"
										:controls="false"
										controlsList="nodownload"
										:height="videosData[1].videoH"
										:width="videosData[1].videoW"
										@timeupdate="videoTimeWatch"
										webkit-playsinline
										playsinline
									>
										<source :src="videosData[1].videoSrc" type="video/mp4">
										Your browser does not support the video tag.
									</video>
								</transition>

								<!-- Third video -->
								<transition name="fade">
									<video
										ref="scf3"
										v-show="(videoNo == 3)"
										:controls="false"
										controlsList="nodownload"
										:height="videosData[2].videoH"
										:width="videosData[2].videoW"
										@timeupdate="videoTimeWatch"
										loop
										webkit-playsinline
										playsinline
									>
										<source :src="videosData[2].videoSrc" type="video/mp4">
										Your browser does not support the video tag.
									</video>
								</transition>

								<!-- Step 1 - Intro -->
								<transition name="fade">
									<div class="video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="step == 1">
										<div id="btn-container" class="button-container text-center black-game-container">
											<div class="row px-4 h-100 align-items-end">
												<div class="col-md-12 border-default-black bg-white text-center p-2-pr">
													<p class="ultra-bold text-size-box-1 mb-0">
														Che sia sigaretta tradizionale o di “nuova generazione” non è facile capire davvero <span class="text-blue">cosa
														si inala con il fumo</span>. È il momento di scoprirlo!
													</p>
												</div>

												<div class="col-12" :class="{'d-none': !(step == 1)}">
													<p class="text-blue ultra-bold text-center text-size-box-2 full-text mb-0">
														Vai avanti per vedere<br>
														cosa c’è dentro<br>
														a ogni tiro di sigaretta.
													</p>
												</div>

												<div class="col-12 text-center">
													<button class="btn btn-blue approf btn-lg rounded-pill px-5 mx-auto text-down-sm-09" @click.prevent="nextStep"><span class="va-m px-3 ultra-bold">ENTRA</span></button>
												</div>
											</div>
										</div>
									</div>
								</transition>

								<!-- First Video Interaction -->
								<transition name="fade">
									<div class="video-end-container" v-if="step == 2 || step == 3 || step == 4">

										<div class="points-1-container h-100 w-100 position-relative d-flex"  v-if="step == 4" style="z-index: 2;">
											<div class="blob point-1 position-absolute" :class="{'animated': animations.first}" @click.prevent="showPopUp(1)"></div>
											<div class="blob point-2 position-absolute" :class="{'animated': animations.second}" @click.prevent="showPopUp(2)"></div>
											<div class="blob point-3 position-absolute" :class="{'animated': animations.third}" @click.prevent="showPopUp(3)"></div>
											<div class="blob point-4 position-absolute" :class="{'animated': animations.fourth}" @click.prevent="showPopUp(4)"></div>
											<div class="blob point-5 position-absolute" :class="{'animated': animations.fifth}" @click.prevent="showPopUp(5)"></div>
											<div class="blob point-6 position-absolute" :class="{'animated': animations.sixth}" @click.prevent="showPopUp(6)"></div>

											<div class="text-center mt-3 align-self-end w-100" style="margin-bottom: 3%;">
												<button class="btn btn-blue approf btn-lg rounded-pill px-5 mx-auto text-down-sm-09" @click.prevent="nextStep" v-if="btnPointShow"><span class="va-m px-3 ultra-bold">AVANTI</span></button>
											</div>
										</div>

										<div id="btn-container" class="button-container text-center black-game-container" style="z-index: 1;">
											<div class="row px-4 h-100">
												<div class="col-md-12 border-default-black bg-white text-center align-self-start padding-black-box">
													<p class="msg-next text-size-box-3 mb-0" v-html="msgNext"></p>
												</div>
												<div class="col-12 text-center mt-3 align-self-end">
													<button class="btn btn-blue approf btn-lg rounded-pill px-5 mx-auto text-down-sm-09" @click.prevent="nextStep" v-if="btnShow" style="z-index: 3;"><span class="va-m px-3 ultra-bold">AVANTI</span></button>
												</div>
											</div>
										</div>

									</div>
								</transition>

								<!-- Second Video Interaction -->
								<transition name="fade">
									<div class="video-end-container" v-if="step == 5|| step == 6 || step == 7">

										<div class="points-1-container h-100 w-100 position-relative d-flex"  v-if="step == 7" style="z-index: 2;">
											<div class="blob point-7 position-absolute" :class="{'animated': animations.seventh}" @click.prevent="showPopUp(7)"></div>
											<div class="blob point-8 position-absolute" :class="{'animated': animations.eighth}" @click.prevent="showPopUp(8)"></div>
											<div class="blob point-9 position-absolute" :class="{'animated': animations.ninth}" @click.prevent="showPopUp(9)"></div>
											<div class="blob point-10 position-absolute" :class="{'animated': animations.tenth}" @click.prevent="showPopUp(10)"></div>
											<div class="blob point-11 position-absolute" :class="{'animated': animations.eleventh}" @click.prevent="showPopUp(11)"></div>
											<div class="blob point-12 position-absolute" :class="{'animated': animations.twelfth}" @click.prevent="showPopUp(12)"></div>

											<div class="text-center mt-3 align-self-end w-100" style="margin-bottom: 3%;">
												<button class="btn btn-blue approf btn-lg rounded-pill px-5 mx-auto text-down-sm-09" @click.prevent="nextStep" v-if="btnPointShow"><span class="va-m px-3 ultra-bold">AVANTI</span></button>
											</div>
										</div>

										<div id="btn-container" class="button-container text-center black-game-container" style="z-index: 1;">
											<div class="row px-4 h-100">
												<div class="col-md-12 border-default-black bg-white text-center align-self-start padding-black-box">
													<p class="msg-next text-size-box-3 mb-0" v-html="msgNext"></p>
												</div>
												<div class="col-12 text-center mt-3 align-self-end">
													<button class="btn btn-blue approf btn-lg rounded-pill px-5 mx-auto text-down-sm-09" @click.prevent="nextStep" v-if="btnShow" style="z-index: 3;"><span class="va-m px-3 ultra-bold">AVANTI</span></button>
												</div>
											</div>
										</div>

									</div>
								</transition>

								<!-- Third Video Interaction -->
								<transition name="fade">
									<div class="video-end-container" v-if="step == 8">

										<div class="points-1-container h-100 w-100 position-relative d-flex"  v-if="step == 8" style="z-index: 2;">
											<div class="blob point-13 position-absolute" :class="{'animated': animations.thirteenth}" @click.prevent="showPopUp(13)"></div>
											<div class="blob point-14 position-absolute" :class="{'animated': animations.fourteenth}" @click.prevent="showPopUp(14)"></div>
											<div class="blob point-15 position-absolute" :class="{'animated': animations.fifteenth}" @click.prevent="showPopUp(15)"></div>
											<div class="blob point-16 position-absolute" :class="{'animated': animations.sixteenth}" @click.prevent="showPopUp(16)"></div>
											<div class="blob point-17 position-absolute" :class="{'animated': animations.seventeenth}" @click.prevent="showPopUp(17)"></div>
											<div class="blob point-18 position-absolute" :class="{'animated': animations.eighteenth}" @click.prevent="showPopUp(18)"></div>
											<div class="blob point-19 position-absolute" :class="{'animated': animations.nineteenth}" @click.prevent="showPopUp(19)"></div>
											<div class="blob point-20 position-absolute" :class="{'animated': animations.twentieth}" @click.prevent="showPopUp(20)"></div>

											<div class="text-center mt-3 align-self-end w-100" style="margin-bottom: 3%;">
												<button class="btn btn-blue approf btn-lg rounded-pill px-5 mx-auto text-down-sm-09" @click.prevent="nextStep" v-if="btnPointShow"><span class="va-m px-3 ultra-bold">AVANTI</span></button>
											</div>
										</div>

										<div id="btn-container" class="button-container text-center black-game-container" style="z-index: 1;">
											<div class="row px-4 h-100">
												<div class="col-8 border-default-black bg-white text-center align-self-start padding-black-box">
													<p class="msg-next text-size-box-3 mb-0" v-html="msgNext"></p>
												</div>
												<div class="col-12 text-center mt-3 align-self-end">
													<button class="btn btn-blue approf btn-lg rounded-pill px-5 mx-auto text-down-sm-09" @click.prevent="nextStep" v-if="btnShow" style="z-index: 3;"><span class="va-m px-3 ultra-bold">AVANTI</span></button>
												</div>
											</div>
										</div>

									</div>
								</transition>

								<!-- PopUp Info point -->
								<transition name="fade">
									<div class="video-end-container d-flex justify-content-center bg-popup" v-if="popUp.show" style="z-index: 10;">
										<div class="pop-up-container border-default-black bg-white text-left align-self-center padding-black-box position-relative">
											<div class="close-icon">
												<img :src="closeIcon" class="img-fluid w-100 h-auto" alt="Close" @click.prevent="closePopUp()">
											</div>
											<div class="pop-up-text" v-html="popUp.html"></div>
										</div>
									</div>
								</transition>

								<!-- END -->
								<transition name="fade">
									<div class="video-end-container" :style="{'backgroundImage': 'url(' + coverUrl + ')' }" v-if="showEnd">
										<div id="btn-container" class="button-container text-center black-game-container">
											<div class="row px-4 h-100 align-items-center">

												<div class="col-md-12 border-default-black bg-white text-center align-self-end" style="padding: 2%;">
													<p class="ultra-bold text-size-box-1 mb-0">
														<span class="text-blue">Ora tocca a te!<br>
														Diventa protagonista</span> con la tua classe:<br>
														crea la tua story contro il fumo<br>
														e scoprine altre nell’area GALLERY.
													</p>
												</div>

												<div class="col-12 text-center align-self-end">
													<a :href="linkUrl.back" class="btn btn-blue approf rounded-pill mr-3 go-next-back mb-2"><span class="va-m">TORNA INDIETRO</span></a>
													<a :href="linkUrl.next" class="btn btn-blue approf rounded-pill go-next-back mb-2"><span class="va-m">RACCONTA LA TUA STORIA</span></a>
												</div>

											</div>
										</div>
									</div>
								</transition>

							</div>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div id="mobile-icon-container" class="container-fluid" v-else>
			<div class="row">
				<div class="col-12">
					<div class="img-rotate position-relative" style="height: 100vh;">
						<img id="phone-gif" :src="rotateScreenUrl" alt="Rotate phone">
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="row">
			<div class="col-12">
				{{timeVideo1}}
			</div>
		</div> -->
	</div>
</template>

<script>
const jQuery = window.jQuery
import { urlBase, themeDir, urlHost } from '../../variables.js'
import axios from 'axios'

export default {
	name: 'SaiCosaFumiComponent',

	data() {
		return {
			ajaxObj: window.ajax_object,
			isMobile: false,
			isPortrait: false,
			videoArray: ['/videos/546753331', '/videos/546753239', '/videos/546753288'],
			videosData: [],
			videoReady: false,
			resolution: {
				max: (window.screen.availWidth > window.screen.availHeight) ? window.screen.availWidth : window.screen.availHeight
			},
			closeIcon: '',
			rotateScreenUrl: '',
			step: 0,
			videoNo: 0,
			coverUrl: '',
			timeVideo1: 0.00,
			msgNext: '',
			animations: {
				first: true,
				second: true,
				third: true,
				fourth: true,
				fifth: true,
				sixth: true,
				seventh: true,
				eighth: true,
				ninth: true,
				tenth: true,
				eleventh: true,
				twelfth: true,
				thirteenth: true,
				fourteenth: true,
				fifteenth: true,
				sixteenth: true,
				seventeenth: true,
				eighteenth: true,
				nineteenth: true,
				twentieth: true
			},
			btnShow: false,
			btnPointShow: false,
			popUp: {
				html: '',
				show: false
			},
			linkUrl: {
				back: '',
				next: ''
			},
			showEnd: false
		}
	},

	methods: {
		videoTimeWatch() {
			if(this.videoNo == 1) {
				this.timeVideo1 = Math.trunc(this.$refs.scf1.currentTime * 100) / 100

				if(this.step == 2 && this.timeVideo1 >= 2.50) {
					this.$refs.scf1.currentTime = 2.50
					this.$refs.scf1.pause()
					this.btnShow = true
				} else if(this.step == 3 && this.timeVideo1 >= 6.50) {
					this.$refs.scf1.currentTime = 6.50
					this.$refs.scf1.pause()
					this.step = this.step + 1 // step 4
				}
			} else if(this.videoNo == 2) {
				this.timeVideo1 = Math.trunc(this.$refs.scf2.currentTime * 100) / 100

				if(this.step == 5 && this.timeVideo1 >= 2.50) {
					this.$refs.scf2.currentTime = 2.50
					this.$refs.scf2.pause()
					this.btnShow = true
				} else if(this.step == 6 && this.timeVideo1 >= 6.50) {
					this.$refs.scf2.currentTime = 6.50
					this.$refs.scf2.pause()
					this.step = this.step + 1 // step 7
				}
			}
		},
		nextStep() {
			this.step = this.step + 1
			this.btnPointShow = false
			this.btnShow = false

			if(this.step == 2) {
				this.videoNo = 1
				this.msgNext = `<span class="title text-blue ultra-bold">SIGARETTE ELETTRONICHE</span><br>
								<span class="title ultra-bold">Le e-cig (electronic cigarette) possono avere forme molto diverse tra loro,
								ma alcuni elementi sono sempre in comune.</span> <span class="title text-blue ultra-bold">Scopri come funzionano!</span>`
				this.$refs.scf1.play()
			} else if(this.step == 3) {
				this.$refs.scf1.play()
				this.btnShow = false
			} else if( this.step == 5) { // *** second video ***
				this.videoNo = 2
				this.msgNext = `<span class="title text-blue ultra-bold">RISCALDATORI DEL TABACCO</span><br>
								<span class="ultra-bold">Come suggerisce il nome</span> <span class="title text-blue ultra-bold">il tabacco viene riscaldato e non bruciato</span>,
								<span class="ultra-bold">ma questo non basta a renderli “sicuri”. Dai un’occhiata dentro e scopri di più.</span>`
				this.$refs.scf2.play()
			} else if(this.step == 6) {
				this.$refs.scf2.play()
			} else if(this.step == 8) { // ** third video ***
				this.videoNo = 3
				this.msgNext = `<span class="title text-blue ultra-bold">LA NICOTINA</span><br>
								<span class="ultra-bold">Si trova nelle sigarette, nei riscaldatori e in molte e-cig. </span><br>
								<span class="ultra-bold">Che forma ha? Come agisce sul corpo?</span><br>
								<span class="ultra-bold">Scoprilo subito!</span>`
				this.$refs.scf3.play()
			} else if(this.step == 9) {
				this.btnPointShow = false
				this.videoNo = 0
				this.showEnd = true
			}
		},

		showPopUp(popNo) {
			if(this.videoNo == 1) {
				if(popNo == 1) {
					this.animations.first = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">BATTERIA:</span> <span class="text-size-box-9 approf">può avere diverse dimensioni, spesso è interna alla e-cig e ricaricabile. Dà</span>
										<span class="text-size-box-9 approf bold">energia</span> <span class="text-size-box-9 approf">per far funzionare i componenti della sigaretta elettronica.</span>`
					this.popUp.show = true
				} else if(popNo == 2) {
					this.animations.second = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">MICROCHIP:</span> <span class="text-size-box-9 approf">un piccolo</span> <span class="text-size-box-9 approf bold">chip elettronico</span>
										<span class="text-size-box-9 approf">necessario per il funzionamento la e-cig. Regola la quantità di svapo prodotta e controlla altre funzioni.</span>`
					this.popUp.show = true
				} else if(popNo == 3) {
					this.animations.third = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">SENSORE:</span> <span class="text-size-box-9 approf bold">rileva quando il fumatore sta aspirando;</span>
										<span class="text-size-box-9 approf">lavora insieme al microchip per far funzionare la sigaretta elettronica.</span>`
					this.popUp.show = true
				} else if(popNo == 4) {
					this.animations.fourth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">ATOMIZZATORE:</span> <span class="text-size-box-9 approf">funziona come una</span> <span class="text-size-box-9 approf bold">resistenza
										elettrica</span><span class="text-size-box-9 approf">, che viene riscaldata e permette di vaporizzare il liquido presente nelle cartucce. Il nome suona bene, ma è più o meno</span>
										<span class="text-size-box-9 approf bold">quello che succede in un termosifone.</span>`

					this.popUp.show = true
				} else if(popNo == 5) {
					this.animations.fifth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">CARTUCCIA:</span> <span class="text-size-box-9 approf">contiene il</span>
										<span class="text-size-box-9 approf bold">liquido</span> <span class="text-size-box-9 approf">che viene</span> <span class="text-size-box-9 approf bold">vaporizzato</span>
										<span class="text-size-box-9 approf">nelle e-cig. La composizione può variare molto ma la sostanza principale è il</span> <span class="text-size-box-9 approf bold">glicole propilenico</span>
										<span class="text-size-box-9 approf">, che viene usato anche come additivo alimentare; tuttavia, se vaporizzato, non sono completamente noti i suoi effetti a lungo termine sulla salute.
										Il liquido delle cartucce può inoltre contenere</span> <span class="text-size-box-9 approf bold">nicotina</span> <span class="text-size-box-9 approf">(responsabile della dipendenza da tabacco) e</span>
										<span class="text-size-box-9 approf bold">aromi</span> <span class="text-size-box-9 approf">vari (che rendono il fumo più appetibile, con effetti a lungo termine sulla salute ancora poco chiari).</span>`
					this.popUp.show = true
				} else if(popNo == 6) {
					this.animations.sixth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">BECCUCCIO:</span> <span class="text-size-box-9 approf">la parte terminale della e-cig serve ad</span>
										<span class="text-size-box-9 approf bold">aspirare</span> <span class="text-size-box-9 approf">il vapore prodotto. È presente in diverse forme, che possono cambiare l’“esperienza” del fumatore (più o meno forte, intensa, ecc..). La forma del beccuccio,
										però, non influisce sul vapore prodotto: non filtra né modifica le sostanze prodotte.</span>`
					this.popUp.show = true
				}
			}

			if(this.videoNo == 2) {
				if(popNo == 7) {
					this.animations.seventh = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">BATTERIA E MICROCHIP:</span> <span class="text-size-box-9 approf">la batteria</span> <span class="text-size-box-9 approf bold">alimenta</span>
										<span class="text-size-box-9 approf">il riscaldatore di tabacco, mentre il chip regola il</span> <span class="text-size-box-9 approf bold">funzionamento</span> <span class="text-size-box-9 approf">dei componenti. Anche i dati del fumatore, come il numero di utilizzi,
										la profondità dell’aspirazione e il numero di sigarette fumate vengono registrati dal chip. Insomma, chi produce le sigarette conosce bene le abitudini di chi fuma.</span>`
					this.popUp.show = true
				} else if(popNo == 8) {
					this.animations.eighth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">LAMA RISCALDANTE:</span> <span class="text-size-box-9 approf">è l’unità che</span> <span class="text-size-box-9 approf bold">riscalda il tabacco.</span>
										<span class="text-size-box-9 approf">Può arrivare fino a circa 350 °C, rispetto ai 900 °C della sigaretta classica. Il vapore prodotto viene poi aspirato dal fumatore.</span>`
					this.popUp.show = true
				} else if(popNo == 9) {
					this.animations.ninth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">OTTURATORE (PLUG):</span> <span class="text-size-box-9 approf">la zona dove viene</span> <span class="text-size-box-9 approf bold">alloggiata</span>
										<span class="text-size-box-9 approf">e bloccata l’unità di tabacco, vicina alla lama riscaldante.</span>`
					this.popUp.show = true
				} else if(popNo == 10) {
					this.animations.tenth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">TUBO A VUOTO:</span> <span class="text-size-box-9 approf">il vapore prodotto, prima di venire aspirato, passa in questa zona e viene</span>
					<span class="text-size-box-9 approf bold">raffreddato</span> <span class="text-size-box-9 approf">per non ustionare la bocca del fumatore.</span>`
					this.popUp.show = true
				} else if(popNo == 11) {
					this.animations.eleventh = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">FILTRO:</span> <span class="text-size-box-9 approf">la struttura è un composto a base di acido polilattico. Come per le sigarette normali, il filtro</span>
					<span class="text-size-box-9 approf bold">non blocca tutte le sostanze dannose:</span> <span class="text-size-box-9 approf">di certo non è una barriera protettiva impenetrabile!
					Questa è una scelta volontaria dei produttori, perché mettere un filtro troppo “efficiente” rischierebbe di rovinare la sensazione del fumatore.</span>`
					this.popUp.show = true
				} else if(popNo == 12) {
					this.animations.twelfth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">UNITÀ DI TABACCO:</span> <span class="text-size-box-9 approf">rispetto alla e-cig, nei riscaldatori di tabacco c’è una vera e propria sigaretta. L’unità di tabacco viene</span>
					<span class="text-size-box-9 approf bold">riscaldata</span> <span class="text-size-box-9 approf">e il vapore prodotto viene aspirato. Le sostanze nocive dovute alla combustione sono ridotte ma il</span>
					<span class="text-size-box-9 approf bold">vapore</span> <span class="text-size-box-9 approf">riscaldato presenta altre</span> <span class="text-size-box-9 approf bold">sostanze tossiche.</span>
					<span class="text-size-box-9 approf">La</span> <span class="text-size-box-9 approf bold">nicotina</span><span class="text-size-box-9 approf">, pur in ridotta quantità, è presente.</span>`
					this.popUp.show = true
				}
			}

			if(this.videoNo == 3) {
				if(popNo == 13) {
					this.animations.thirteenth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">LA NICOTINA</span><br><span class="text-size-box-9 approf">È una sostanza stimolante</span> <span class="text-size-box-9 approf bold">naturalmente presente nelle foglie del tabacco.</span>
										<span class="text-size-box-9 approf">Non è cancerogena, ma è</span> <span class="text-size-box-9 approf bold">tossica:</span> <span class="text-size-box-9 approf">può essere letale se ingerita e, se inalata in grandi quantità, può causare intossicazione acuta.</span><br>
										<span class="text-size-box-9 approf">Anche a bassi livelli,</span> <span class="text-size-box-9 approf bold">la nicotina non è innocua.</span><br>
										<span class="text-size-box-9 approf">Agisce sul nostro corpo e su molti organi, dal cervello all’intestino, affatica il cuore e causa una</span> <span class="text-size-box-9 approf bold">forte dipendenza.</span>`
					this.popUp.show = true
				} else if(popNo == 14) {
					this.animations.fourteenth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">CERVELLO</span><br><span class="text-size-box-9 approf">I bersagli principali sono i</span> <span class="text-size-box-9 approf bold">recettori nicotinici:</span> <span class="text-size-box-9 approf">sono presenti</span>
										<span class="text-size-box-9 approf bold">nel sistema nervoso centrale</span> <span class="text-size-box-9 approf">e in quello</span>
										<span class="text-size-box-9 approf bold">periferico</span> <span class="text-size-box-9 approf">ma anche nei</span> <span class="text-size-box-9 approf bold">muscoli</span><span class="text-size-box-9 approf">, a livello delle giunzioni neuromuscolari. Quando si lega ai</span>
										<span class="text-size-box-9 approf bold">recettori nicotinici</span><span class="text-size-box-9 approf">, la nicotina stimola il</span>
										<span class="text-size-box-9 approf bold">rilascio di neurotrasmettitori</span> <span class="text-size-box-9 approf">diversi, sostanze attraverso le quali il cervello “comunica”, generando per alcuni minuti sensazioni come</span>
										<span class="text-size-box-9 approf bold">gratificazione, sazietà, eccitazione…</span>
										<hr class="pointed">
										<span class="text-size-box-9 approf">La</span> <span class="text-size-box-9 approf bold">dopamina</span> <span class="text-size-box-9 approf">provoca un senso di gioia e gratificazione. La</span>
										<span class="text-size-box-9 approf bold">norepinefrina</span> <span class="text-size-box-9 approf">riduce l’appetito e ha effetto eccitante. Le</span>
										<span class="text-size-box-9 approf bold">endorfine</span> <span class="text-size-box-9 approf">provocano un rilascio della tensione e diminuzione dell’ansia. L’</span><span class="text-size-box-9 approf bold">acetilcolina</span>
										<span class="text-size-box-9 approf">ha effetto eccitante. La</span> <span class="text-size-box-9 approf bold">serotonina</span>
										<span class="text-size-box-9 approf">migliora l’umore e contribuisce a ridurre l’appetito. Gli effetti “positivi” della nicotina dovuti a questi neurotrasmettitori</span> <span class="text-size-box-9 approf bold">durano però pochi minuti.</span>`
					this.popUp.show = true
				} else if(popNo == 15) {
					this.animations.fifteenth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">CERVELLO</span><br><span class="text-size-box-9 approf">Il lato negativo è che la nicotina dà una forte dipendenza fin dalle prime assunzioni. Infatti la dopamina rilasciata stimola il</span>
										<span class="text-size-box-9 approf bold">circuito del piacere</span><span class="text-size-box-9 approf">: il nostro cervello registra l’esperienza come gratificante e ci spinge ad assumere altra nicotina. La</span>
										<span class="text-size-box-9 approf bold">gratificazione</span><span class="text-size-box-9 approf">, il rilassamento e la maggiore attenzione diventano una ragione per continuare a fumare. In questo modo si può instaurare una</span>
										<span class="text-size-box-9 approf bold">forte dipendenza da tabacco e sigarette</span> <span class="text-size-box-9 approf">– piene zeppe di</span> <span class="text-size-box-9 approf bold">altre sostanze tossiche e cancerogene.</span>
										<hr class="pointed">
										<span class="text-size-box-9 approf">La dipendenza da nicotina ha un’altra faccia nascosta. Come per altre sostanze, smettere con la nicotina può causare una vera e propria</span>
										<span class="text-size-box-9 approf bold">sindrome da astinenza</span><span class="text-size-box-9 approf">, con insonnia, irritabilità e forte necessità di riaccendere una sigaretta. Smettere, però, è possibile.
										Dire addio al tabacco e alla nicotina è un</span> <span class="text-size-box-9 approf bold">guadagno per tutta la vita!</span>`
					this.popUp.show = true
				} else if(popNo == 16) {
					this.animations.sixteenth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">TRONCO E MIDOLLO</span><br><span class="text-size-box-9 approf">Il tronco e i gangli del sistema nervoso simpatico vengono stimolati dalla nicotina. Dicono al cuore di</span>
										<span class="text-size-box-9 approf bold">battere più velocemente</span> <span class="text-size-box-9 approf">, anche se non si è sotto sforzo fisico. Stimolano la produzione delle ghiandole, con</span>
										<span class="text-size-box-9 approf bold">aumento delle secrezioni di saliva e bronchi.</span>`
					this.popUp.show = true
				} else if(popNo == 17) {
					this.animations.seventeenth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">CUORE</span><br><span class="text-size-box-9 approf">Il cuore viene stimolato a</span>
										<span class="text-size-box-9 approf bold">battere più velocemente</span> <span class="text-size-box-9 approf">dal sistema nervoso centrale e dall’adrenalina. La</span> <span class="text-size-box-9 approf bold">frequenza respiratoria aumenta</span>
										<span class="text-size-box-9 approf">e i respiri sono meno profondi. È un po’ come se il cuore di un fumatore andasse di corsa anche quando non si corre. Inoltre il muscolo</span>
										<span class="text-size-box-9 approf bold">cardiaco fa più fatica a pompare</span> <span class="text-size-box-9 approf">il sangue perché le vene si restringono. Per questi motivi, nel tempo, ci si espone a</span>
										<span class="text-size-box-9 approf bold">malattie cardiovascolari.</span>`
					this.popUp.show = true
				} else if(popNo == 18) {
					this.animations.eighteenth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">VASI SANGUIGNI</span><br><span class="text-size-box-9 approf">La nicotina agisce sui vasi sanguigni, restringendoli. Questo porta a un</span>
										<span class="text-size-box-9 approf bold">aumento della pressione sanguigna</span> <span class="text-size-box-9 approf"> perché il cuore deve “spingere” il sangue dentro a vene e arterie più strette e che fanno resistenza.
										Insieme alle altre sostanze nocive del tabacco, la nicotina irrigidisce le arterie e provoca</span>
										<span class="text-size-box-9 approf bold">problemi di vascolarizzazione</span> <span class="text-size-box-9 approf">– in altre parole, è più difficile irrorare bene tutte le zone del corpo.</span>`
					this.popUp.show = true
				} else if(popNo == 19) {
					this.animations.nineteenth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">GHIANDOLE SURRENALI</span><br><span class="text-size-box-9 approf">La nicotina stimola la porzione midollare delle ghiandole surrenali: questo aumenta la</span>
										<span class="text-size-box-9 approf bold">produzione di adrenalina e noradrenalina</span><span class="text-size-box-9 approf">, che a loro volta stimolano il rilascio di glucosio, restringono i vasi sanguigni, aumentano la pressione sanguigna,
										la respirazione e la frequenza cardiaca.</span>`
					this.popUp.show = true
				} else if(popNo == 20) {
					this.animations.twentieth = false
					this.popUp.html = `<span class="text-blue ultra-bold text-size-box-9 approf">INTESTINO</span><br><span class="text-size-box-9 approf">La nicotina stimola direttamente e indirettamente l’intestino.</span>
										<span class="text-size-box-9 approf bold">Può aumentare la motilità intestinale</span> <span class="text-size-box-9 approf">e causare diarrea (ecco il perché dello stimolo ad andare in bagno!), oltre a diminuire l’appetito.
										Inoltre, a livello dello stomaco,</span> <span class="text-size-box-9 approf bold">aumenta la produzione di acidi gastrici.</span>`
					this.popUp.show = true
				}
			}
		},

		closePopUp() {
			if(this.step == 4) {
				this.popUp.show = false
				if (!this.animations.first && !this.animations.second && !this.animations.third && !this.animations.fourth && !this.animations.fifth && !this.animations.sixth) {
					this.btnPointShow = true
				}
			}
			if(this.step == 7) {
				this.popUp.show = false
				if (!this.animations.seventh && !this.animations.eighth && !this.animations.ninth && !this.animations.tenth && !this.animations.eleventh && !this.animations.twelfth) {
					this.btnPointShow = true
				}
			}
			if(this.step == 8) {
				this.popUp.show = false
				if (!this.animations.thirteenth && !this.animations.fourteenth && !this.animations.fifteenth && !this.animations.sixteenth && !this.animations.seventeenth && !this.animations.eighteenth && !this.animations.nineteenth && !this.animations.twentieth) {
					this.btnPointShow = true
				}
			}
		},

		getVimeoVideosData() {
			let _self = this

			for (let i = 0; i < this.videoArray.length; i++) {
				let formData = new FormData()
				formData.append('_nounce_value', this.ajaxObj._nounce_value)
				formData.append('action', 'nl_vimeo_video_info')
				formData.append('video_uri', this.videoArray[i])

				axios.post( this.ajaxObj.ajax_url, formData)
					.then(function(response){
						// console.log(response.data.body.files)
						_self.checkResolution(response.data.body.files, i)
					})
			}
		},
		isMobileFn() {
			this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		},
		isPortraitFn() {
			this.isPortrait = (window.innerHeight > window.innerWidth)
		},
		handleOrientationChange() {
			this.isMobileFn()
			this.isPortraitFn()
			if(this.isPortrait) {
				this.isMobile = true
				this.isPortrait = false
				this.removeEvent()
			}
		},
		removeEvent() {
			window.removeEventListener("orientationchange", this.handleOrientationChange, true)
		},
		calculateVideoWidth() {
			let screen_h = screen.availHeight
			let screen_w = ((screen_h * 16) / 9) - 20

			jQuery('#full-video-container').css('max-width', screen_w + 'px')
			jQuery('.pop-up-container').css('max-height', (jQuery('.inner-vid-conteiner').outerHeight() - 30)  + 'px')
		},
		checkResolution(vimeoFiles, index) {
			let _self = this
			let lastVal = 0
			let rightObj = {};

			for (let urlData of vimeoFiles) {
				let videoResMaxVal = urlData.height > urlData.width ? urlData.height : urlData.width

				if(Math.abs(this.resolution.max - videoResMaxVal) <= Math.abs(this.resolution.max - lastVal)) {
					rightObj = urlData
					lastVal = videoResMaxVal
					// console.log(rightObj)
				}
			}

			let tmpArray = this.videosData
			this.videosData = []
			tmpArray[index] = {
				videoSrc: rightObj.link,
				videoH: rightObj.height,
				videoW: rightObj.width
			}
			this.videosData = tmpArray
			if(this.videosData.length == 3) setTimeout(function(){ _self.videoReady = true; }, 100)
		}
	},

	mounted() {
		let _self = this
		jQuery('#wrapper-navbar, #wrapper-footer').addClass('d-none')
		// jQuery('#wrapper-navbar').addClass('d-none')

		this.themeUrl = urlBase + themeDir

		this.isMobileFn()
		this.isPortraitFn()
		if(this.isMobile && this.isPortrait) {
			this.rotateScreenUrl = this.themeUrl + 'img/rotate_screen.gif'
			window.addEventListener("orientationchange", this.handleOrientationChange, true)
		}

		jQuery(window).resize(function(){
			_self.calculateVideoWidth()
		})
		this.getVimeoVideosData()

		this.coverUrl = this.themeUrl + 'img/covers/Sai_cosa_fumi_COVER_BACK.jpg'
		this.closeIcon = this.themeUrl + 'img/x.svg'
		this.step = 1

		this.linkUrl.back = urlBase + urlHost + 'sai-cosa-fumi'
		this.linkUrl.next = urlBase + urlHost +'/login'
	},

	updated() {
		this.calculateVideoWidth()
	}
}
</script>

<style scoped>
	.pop-up-text >>> .text-size-box-9.approf {line-height: 1.4 !important;}
	.go-next-back {
		padding-left: 2.8% !important;
		padding-right: 2.8% !important;
		padding-bottom: 0.5% !important;
		padding-top: 0.5% !important;

		margin: 1.2%;
	}
	@media (max-width: 991.98px) {
		.text-size-box-10.end {
			font-size: 2.5rem;
		}
	}
	@media (max-width: 767.98px) {
		.full-text {
			font-size: 1.3rem !important;
		}
		.text-size-box-10.end {
			font-size: 1.8rem;
		}
	}
	@media (min-width: 992px) {
		.go-next-back {font-size: 1.1rem !important;}
	}
	video {
		width: 100%;
		height: auto;
	}
	.inner-vid-conteiner {
		width: 100%;
		position: absolute;
		top:50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.inner-vid-wrap {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}
	#btn-container {
		position: absolute;
		bottom: 5%;
		top: 2%;
		left: 50%;
		transform: translateX(-50%);
	}

	.btn.game {
		border-width: 4px;
		font-weight: 800;
		font-size: 1.5vw;
	}
	@media (max-width: 991.98px) {
		.btn {
			padding: .344rem 3rem;
		}
		.btn.game {
			font-size: .9rem;
		}
		#popUp p {
			font-size: 1rem !important;
		}
	}
	@media (max-width: 767.98px) {
		#popUp p {
			font-size: 0.94rem !important;
		}
	}
	.video-end-container {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	}
	#phone-gif {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);;
	}
	#full-video-container {height: 100vh;}
	.padding-black-box {
		padding: 1.5%;
	}

	.fade-enter-active/*, .fade-leave-active*/ {
		transition: opacity 0.9s;
	}
	.fade-enter/*, .fade-leave-to */ {
		opacity: 0;
	}

	/** Points */
	.point-1 {
		left: 27%;
		top: 66%;
	}
	.point-2 {
		left: 43.5%;
		top: 51%;
	}
	.point-3 {
		left: 51%;
		top: 54.5%;
	}
	.point-4 {
		left: 52.4%;
		top: 46%;
	}
	.point-5 {
		left: 58.5%;
		top: 42.5%;
	}
	.point-6 {
		left: 69%;
		top: 41%;
	}
	.point-7 {
		left: 32%;
		top: 60%;
	}
	.point-8 {
		left: 43%;
		top: 57%;
	}
	.point-9 {
		left: 66.5%;
		top: 43%;
	}
	.point-10 {
		left: 69.4%;
		top: 41%;
	}
	.point-11 {
		left: 73.4%;
		top: 38.4%;
	}
	.point-12 {
		left: 78.2%;
		top: 35%;
	}
	.point-13 {
		left: 46%;
		top: 50%;
	}
	.point-14 {
		left: 74.4%;
		top: 9.5%;
	}
	.point-15 {
		left: 76.5%;
		top: 15.5%;
	}
	.point-16 {
		left: 77%;
		top: 24%;
	}
	.point-17 {
		left: 74%;
		top: 55%;
	}
	.point-18 {
		left: 87.6%;
		top: 56.5%;
	}
	.point-19 {
		left: 68%;
		top: 74.5%;
	}
	.point-20 {
		left: 72%;
		top: 85%;
	}

	.pop-up-container {
		width: 80%;
		overflow-y: auto;
		font-weight: 400;
	}
	.bg-popup {background-color: rgba(0,0,0,0.8);}
	.close-icon {
		position: absolute;
		top: 0px;
		right: 0px;
		width: 6%;
		height: auto;
		transition: all .2s ease-in-out;
	}
	.close-icon:hover {opacity: 0.5;}
	.pop-up-text {padding-top: 2.5%;}
	#btn-go {
		left: 50%;
		bottom: 9%;
		transform: translateX(-50%);
	}
	/** Pulsed points animation */
	.blob {
		cursor: pointer;
		background: #5b5b68;
		border: 2px solid #ededed;
		border-radius: 50%;
		margin: 0;
		height: 2.7vh;
		width: 2.7vh;
		min-width: 14px;
		min-height: 14px;
	}
	.blob.animated {
		background: #2D32A2;
		box-shadow: 0 0 0 0 rgba(45, 50, 162, 1);
		transform: scale(1);
		-webkit-animation: 1.8s infinite;
		animation: pulse 1.8s infinite;
	}
	.points-wrapper {z-index: 10;}
	.p-2-pr {
		padding: 1.5%;
	}

	@-webkit-keyframes pulse {
		0% {
			-webkit-transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
		}
		70% {
			-webkit-transform: scale(1);
			box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
		}
		100% {
			-webkit-transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		}
	}
	@keyframes pulse {
		0% {
			-webkit-transform: scale(0.95);
			transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
		}
		70% {
			-webkit-transform: scale(1);
			transform: scale(1);
			box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
		}
		100% {
			-webkit-transform: scale(0.95);
			transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		}
	}
</style>
